import React, {useState, useEffect} from 'react';
import { SafeAreaView } from 'react-native-safe-area-context';
import { Button, Divider, Layout, Text } from '@ui-kitten/components';
import { StyleSheet, ScrollView, View, Dimensions } from 'react-native';
import { BarCodeScanner } from 'expo-barcode-scanner';
import * as RootNavigation from '../../../root.navigation.js';

const height = Dimensions.get('window').height;
const width = Dimensions.get('window').width;
export const QrScreen =  ( {toggle, setSerialNo}) => {
  const [hasPermission, setHasPermission] = useState(null);
  const [scanned, setScanned] = useState(false);

  useEffect(() => {
    const getBarCodeScannerPermissions = async () => {
      const { status } = await BarCodeScanner.requestPermissionsAsync();
      console.log(status);
      setHasPermission(status === 'granted');
    };

    getBarCodeScannerPermissions();
  }, []);

  const handleBarCodeScanned = ({ type, data }) => {
   setScanned(true);
   setSerialNo(data);
   toggle()
 };

 if (hasPermission === null) {
   return <Text>درخواست دسترسی به دوربین</Text>;
 }
 if (hasPermission === false) {
   return <Text>اپلیکیشن به دوربین دسترسی ندارد.</Text>;
 }

  return (
      <View style={styles.container}>
          <BarCodeScanner
            onBarCodeScanned={scanned ? undefined : handleBarCodeScanned}
            style={{height: height/3}}
          />
      </View>
  );
};

const styles = StyleSheet.create({
  container:{
    flex:1,
  },
});
